/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): index.esm.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import SelectorEngine from './src/dom/selector-engine';

//export { default as Alert } from './src/alert'
//export { default as Button } from './src/button'
export { default as Carousel } from './src/carousel'
export { default as Collapse } from './src/collapse'
export { default as Dropdown } from './src/dropdown'
export { default as Modal } from './src/modal'
export { default as Offcanvas } from './src/offcanvas'
// *Popup.js* export { default as Popover } from './src/popover'
//export { default as ScrollSpy } from './src/scrollspy'
//export { default as Tab } from './src/tab'
//export { default as Toast } from './src/toast'
// *Popup.js* export { default as Tooltip } from './src/tooltip'

export { default as FocusTo } from './src/focus-to'
export { default as NavbarScroll } from './src/navbar-scroll'
export { default as NavbarFixed } from './src/navbar-fixed'
export { default as Consent } from './src/consent'
export { default as CarouselImagegallery } from './src/carousel-imagegallery'

export { default as Licensecheck } from './src/licensecheck'
export { default as MapGen } from './src/map'
export { default as Effects } from './src/effects'

const youtubeElems = SelectorEngine.find('[data-ome-consent="YouTube"]');
if (youtubeElems.length > 0) import("./src/youtube").then(module => {module.default._processHistory(window.Youtube ?? []); window.Youtube = module.default});

const vimeoElems = SelectorEngine.find('[data-ome-consent="Vimeo"]');
if (vimeoElems.length > 0) import("./src/vimeo").then(module => {module.default._processHistory(window.Vimeo ?? []); window.Vimeo = module.default});

const countdownElems = SelectorEngine.find(".ome-countdown");
if (countdownElems.length > 0) import('./src/countdown').then(module => new module.default(countdownElems));
